import React, { Suspense } from 'react';
import DynamicSidebar from './DynamicSidebar';
import Header from './Header';
import TabsManager from './TabsManager';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const FIXED_SIDEBAR_WIDTH = 300;

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="h-screen flex flex-col bg-gray-100 overflow-hidden">
      <Header sidebarWidth={FIXED_SIDEBAR_WIDTH} />
      <div className="mt-16 h-[calc(100vh-64px)] flex min-h-0">
        <DynamicSidebar width={FIXED_SIDEBAR_WIDTH} />
        <div className="flex-1 flex flex-col min-w-0">
          <TabsManager />
          <main className="flex-1 p-6 overflow-auto min-w-0">
            <Suspense fallback={
              <div className="flex items-center justify-center h-64">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                  <p className="text-gray-600">页面加载中...</p>
                </div>
              </div>
            }>
              {children}
            </Suspense>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout; 